import { createSlice } from '@reduxjs/toolkit';
import LogAction from 'models/enums/LogAction';
import ParamsService from 'services/ParamsService';
import { dispatch } from 'store';
import { ParamToUpdate, ParamValue, ParamsProps, ParamsType } from 'types/params';

// initial state
const initialState: ParamsProps = {
    isEditing: false,
    isLoading: false,
    newParams: []
};

// ==============================|| SLICE - PARAMS ||============================== //

const params = createSlice({
    name: 'params',
    initialState,
    reducers: {
        initilizeEdit(state, action) {
            state.isEditing = action.payload;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        changeParamValue(state, action) {
            state.newParams = action.payload;
        },
        reset(state) {
            state.isEditing = false;
            state.newParams = [];
        }
    }
});

export default params.reducer;

const paramsService = new ParamsService();

export const onParamsEdit = (state: boolean) => dispatch(params.actions.initilizeEdit(state));
export const resetParams = () => dispatch(params.actions.reset());

export const onChangeParamValue = (param: ParamsType, id: string, value: number, paramsToUpdate: ParamToUpdate[]) => {
    let newParams: ParamToUpdate[] = [];
    const newValue: ParamValue = { id, value };

    const paramIndex = paramsToUpdate.findIndex((p) => p.param === param);

    // Se il parametro esiste nell'array paramsToUpdate
    if (paramIndex > -1) {
        const valueIndex = paramsToUpdate[paramIndex].values.findIndex((p) => p.id === id);

        // Se il valore esiste già all'interno dei valori del parametro
        if (valueIndex > -1) {
            newParams = paramsToUpdate.map((p) => {
                if (p.param === param) {
                    // Copia tutti i valori del parametro e aggiorna solo il valore specifico
                    const newValues = p.values.map((p) => {
                        if (p.id === id) return { ...p, value };
                        return p;
                    });
                    return { ...p, values: newValues };
                }
                return p;
            });
        } else {
            // Se il valore non esiste ancora, aggiungi il nuovo valore ai valori del parametro corrente
            const newValues = [...paramsToUpdate[paramIndex].values, newValue];
            newParams = paramsToUpdate.map((p) => {
                if (p.param === param) {
                    return { ...p, values: newValues };
                }
                return p;
            });
        }
    } else {
        // Se il parametro non esiste, aggiungi un nuovo parametro con il valore
        newParams = [...paramsToUpdate, { param, values: [newValue] }];
    }

    dispatch(params.actions.changeParamValue(newParams));
};

export const onSaveParams = async (
    tenantId: string,
    userId: string,
    username: string,
    simulationId: string | null,
    paramsToUpdate: ParamToUpdate[]
) => {
    try {
        dispatch(params.actions.setIsLoading(true));
        const res = await paramsService.updateParams({
            tenantId,
            userId,
            username,
            action: LogAction.EDIT,
            simulazioneId: simulationId,
            params: paramsToUpdate
        });
        dispatch(params.actions.setIsLoading(false));
        return res;
    } catch (error) {
        dispatch(params.actions.setIsLoading(false));
        return false;
    }
};
